module.exports = __webpack_public_path__ + "img/step_cright_img04.076d1e1b.png";